import React, { useState } from "react";
import MemoizedDomainSelect from "./MemoizedDomainSelect";
import { CSSTransition } from "react-transition-group";

export default function DomainSidebar({ open, setOpen, setCurrentDomain }) {
  const [selectedDomain, setSelectedDomain] = useState();
  const [error, setError] = useState(false);
  return (
    <>
      <CSSTransition in={open} timeout={300} classNames="backdrop" appear>
        <div onClick={() => setOpen(false)}></div>
      </CSSTransition>
      <div className={`sidedrawer ${open ? "open" : ""}`}>
        <div
          onClick={() => {
            setOpen((prevOpen) => !prevOpen);
          }}
          className="filter-button"
          role="button"
        >
          <svg
            style={{ height: "20px", width: "20px" }}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.5 0c.273 0 .5.272.5.6v1.2c0 .328-.227.6-.5.6H.5c-.273 0-.5-.272-.5-.6V.6C0 .272.227 0 .5 0h11ZM9.907 5.4c0-.328-.148-.6-.326-.6H2.42c-.179 0-.326.272-.326.6v1.2c0 .328.147.6.326.6H9.58c.178 0 .326-.272.326-.6V5.4ZM8.51 10.2c0-.328-.095-.6-.209-.6H3.698c-.115 0-.21.272-.21.6v1.2c0 .328.095.6.21.6h4.604c.114 0 .21-.272.21-.6v-1.2Z"
              fill="#434A54"
            />
          </svg>
        </div>
        <div className="sidedrawer-content">
          <div style={{ paddingLeft: "30px", paddingRight: "30px" }}>
            <div className="sidedrawer-header">
              <h2>
                <svg
                  style={{
                    height: "10px",
                    width: "10px",
                    marginRight: "5px",
                    display: "inline-block",
                  }}
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 12 12"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 0c.273 0 .5.272.5.6v1.2c0 .328-.227.6-.5.6H.5c-.273 0-.5-.272-.5-.6V.6C0 .272.227 0 .5 0h11ZM9.907 5.4c0-.328-.148-.6-.326-.6H2.42c-.179 0-.326.272-.326.6v1.2c0 .328.147.6.326.6H9.58c.178 0 .326-.272.326-.6V5.4ZM8.51 10.2c0-.328-.095-.6-.209-.6H3.698c-.115 0-.21.272-.21.6v1.2c0 .328.095.6.21.6h4.604c.114 0 .21-.272.21-.6v-1.2Z"
                    fill="#434A54"
                  />
                </svg>
                Filters:
              </h2>
              <button
                onClick={() => setOpen(false)}
                type="button"
                className="close"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <form
            onSubmit={(event) => {
              event.preventDefault();
              setError(false);
              if (!selectedDomain) {
                setError(true);
              } else {
                setCurrentDomain(selectedDomain);
                setOpen(false);
              }
            }}
            className="sidedrawer-form"
          >
            <div className={`form-group col-xs-12 ${error ? "has-error" : ""}`}>
              <label className="control-label">Groups and Locations</label>
              <MemoizedDomainSelect setSelectedDomain={setSelectedDomain} />
              {error ? <div className="help-block">Must select a group or location</div> : null}
            </div>
            <div className="submit-buttons-container col-xs-12">
              <button type="submit" className="btn btn-primary">
                Apply
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
